import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-12/task-02";

const task: Slide = {
  titleHtml:
    "Listen to the sounds and match them to the correct source source location. After that match the sound source<br>locations to the time and level of arrival of sound waves at the left and right ear respectively.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
